{
  "brand": "OnBrand Mail",
  "brandTagline": "OnBrand Mail — firmas de correo, gestionadas de forma centralizada.",
  "language": "Idioma",
  "sampleData": "Datos de ejemplo",
  "sampleDataHint": "VITE_MOCK_SESSION está activo: todo lo que ves son datos de prueba.",
  "toggleColorScheme": "Cambiar tema",
  "switchToLight": "Cambiar a modo claro",
  "switchToDark": "Cambiar a modo oscuro",
  "accountMenu": "Menú de cuenta",
  "signOut": "Cerrar sesión",
  "signIn": "Iniciar sesión",
  "retry": "Reintentar",
  "tryAgain": "Intentar de nuevo",
  "loading": "Cargando…",
  "save": "Guardar",
  "cancel": "Cancelar",
  "delete": "Eliminar",
  "edit": "Editar",
  "create": "Crear",
  "search": "Buscar",
  "back": "Atrás",
  "backToTenant": "Volver al inquilino",
  "next": "Siguiente",
  "close": "Cerrar",
  "yes": "Sí",
  "no": "No",
  "manage": "Gestionar",
  "never": "Nunca",
  "unknown": "Desconocido",
  "copy": "Copiar",
  "copied": "Copiado",
  "refresh": "Actualizar",
  "continue": "Continuar",
  "confirm": "Confirmar",
  "remove": "Quitar",
  "add": "Añadir",
  "open": "Abrir",
  "download": "Descargar",
  "upload": "Subir",
  "settings": "Configuración",
  "actions": "Acciones",
  "status": "Estado",
  "name": "Nombre",
  "email": "Correo",
  "description": "Descripción",
  "enabled": "Activado",
  "disabled": "Desactivado",
  "active": "Activo",
  "inactive": "Inactivo",
  "none": "Ninguno",
  "all": "Todos",
  "optional": "Opcional",
  "required": "Obligatorio",
  "any": "Cualquiera",
  "done": "Hecho",
  "reason": "Motivo",
  "unknownError": "Error desconocido.",
  "apiUnreachableTitle": "El portal no pudo contactar con la API",
  "apiUnreachableHint": "En desarrollo la API corre en el puerto 5138 y Vite hace de proxy. Comprueba que esté en marcha.",
  "signInMicrosoftGoogle": "OnBrand Mail usa tu cuenta de trabajo de Microsoft o Google.",
  "signInGoogle": "OnBrand Mail usa tu cuenta de Google Workspace.",
  "signInMicrosoft": "OnBrand Mail usa tu cuenta de trabajo de Microsoft.",
  "continueMicrosoft": "Continuar con Microsoft",
  "continueGoogle": "Continuar con Google",
  "noSignInTitle": "Inicio de sesión no configurado",
  "noSignInBody": "Este entorno aún no tiene proveedor de identidad. Un administrador debe configurarlo antes de que alguien pueda entrar.",
  "accessNotGrantedTitle": "Acceso aún no concedido",
  "accessNotGrantedBody": "Has iniciado sesión como {{email}}, pero esta cuenta aún no tiene ningún rol. Un administrador debe concederte acceso antes de que veas nada.",
  "age": {
    "unknown": "en un momento desconocido",
    "justNow": "ahora mismo",
    "minutesAgo": "hace {{count}} minutos",
    "oneHourAgo": "hace 1 hora",
    "hoursAgo": "hace {{count}} horas",
    "oneDayAgo": "hace 1 día",
    "daysAgo": "hace {{count}} días"
  }
}
